import { IOnInit } from "angular";

export class ContractInstanceContactComponentController implements IOnInit {
  static $inject = [];
  constructor() {}

  $onInit(): void {}
}
